import React from 'react'
// containers
import BusinessUnitsContainer from 'containers/BusinessUnits'

const BusinessUnitsSettingsPage: React.FC = () => <BusinessUnitsContainer />

export default BusinessUnitsSettingsPage

